import {createApi} from '@reduxjs/toolkit/query/react'
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {addBaseQueryParams, BaseQueryParams, transformResponse} from "@commons/utils/APIParams";
import {SpoolAzienda} from "@commons/mapping/DataTablesSchema";
import {config} from "@commons/config.instance";

export interface TabellaSpool extends BaseQueryParams {
    idAziendaMaster: number | null,
    idAzienda: number | null,
    nowId: number | null,
}

export const spoolApi = createApi({
    reducerPath: 'spoolApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    tagTypes: ['filesSpool'],
    endpoints: (builder) => ({

        //http://fpnet.local/FPNet2021/tool/109-110/spool?draw=1&start=0&length=25&search%5Bvalue%5D=&search%5Bregex%5D=false&auth_token=4046f7f8afd22b86d50e616ee048f8a7&nowId=1676976554855&mode=DataTables&nowId=1676976554854&view=Grid
        getTabellaSpool: builder.query<SpoolAzienda, Partial<TabellaSpool>>({
            query: (filter) => {
                let params: string[] = addBaseQueryParams(filter);
                let url = `/tool/${filter.idAziendaMaster}-${filter.idAzienda}/spool`;
                return url + `${params.length > 0 ? '?' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse: (response: any, meta: any, arg: any) => {
                const r: SpoolAzienda = transformResponse(response, meta, arg) as SpoolAzienda;
                //https://stackoverflow.com/questions/70408411/how-to-get-x-total-count-header-with-rtk-query
                // Integro risposta con info contenute headers
                r.spoolSize = Number(meta.response.headers.get('fpnet-spoolsize'));
                return r;
            }
        }),

        deleteFile: builder.mutation<void, string>({
            query: (URI) => ({
                url: URI ? URI : '',
                method: 'DELETE'
            }),
            invalidatesTags: [{type: 'filesSpool', id: 'LIST'}],
        }),
    }),
})
export const {useGetTabellaSpoolQuery, useDeleteFileMutation} = spoolApi;